export const ADD_APPOINTMENT = 'ADD_APPOINTMENT';